import {
    ROWS_PER_PAGE_OPTION_ACTION_BEGIN,
    ROWS_PER_PAGE_OPTION_ACTION_SUCCESS,
    ROWS_PER_PAGE_OPTION_ACTION_FAIL
  } from '../middleware/types'
  
  const initialState = {
    SUBMIT_loading: false,
    error: {},
    response:{}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case ROWS_PER_PAGE_OPTION_ACTION_BEGIN:
        return {
          ...state,
          SUBMIT_loading: true
        }
      case  ROWS_PER_PAGE_OPTION_ACTION_SUCCESS:
          return {
              ...state,
              SUBMIT_loading: false,
              response: action.payload
            }
      case ROWS_PER_PAGE_OPTION_ACTION_FAIL:
        return {
          ...state,
          SUBMIT_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }